// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010904/js/" + chunkId + "." + {"44":"38d87f25","225":"ae575bee","481":"314bae0a","486":"263306a8","770":"9855e9c4"}[chunkId] + ".0.3904812996186723.chunk.js";
};